import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Message} from './message';

@Injectable({providedIn: 'root'})
export class ToastService {
  messages: Message[] = [];

  add(message: Message) {
    this.messages.push(message);
    return message;
  }

  addTemporary(message: Message, duration = 5000) {
    this.add(message);
    message.timeoutId = setTimeout(() => this.remove(message), duration);
    return message;
  }

  remove(message: Message) {
    this.messages.splice(this.messages.indexOf(message), 1);
  }

  info(title: string, message: string) {
    return this.addTemporary({
      type: 'info',
      title,
      message,
    });
  }

  success(title: string, message: string) {
    return this.addTemporary({
      type: 'success',
      title,
      message,
    });
  }

  warning(title: string, message: string) {
    return this.addTemporary({
      type: 'warning',
      title,
      message,
    });
  }

  error(title: string, message: string, error?: unknown) {
    let errorMessage = '';
    if (error) {
      errorMessage =
        error instanceof HttpErrorResponse ? error.error?.message :
          error instanceof Error ? error.message :
            String(error);
      console.error(title, message, errorMessage);
    }
    return this.add({
      type: 'error',
      title,
      message,
      actions: [
        {
          title: $localize`:@@error-report-button:Fehler melden`,
          action: () => {
            this.reportError(title, message, errorMessage, error);
          },
        },
      ],
    });
  }

  private reportError(title: string, message: string, errorMessage: string, error: unknown) {
    let errorStr: string;
    try {
      errorStr = JSON.stringify(error);
    } catch {
      errorStr = String(error);
    }
    const body = $localize`:@@error-report-message:\
# FIT Fehlerbericht

## Beschreibung
Bitte beschreiben Sie kurz, was zu diesem Fehler geführt hat:
-

## Screenshot
Bitte fügen Sie einen Screenshot an:
-

## Sonstige
Bitte geben Sie sonstige Details an, z.B. Ihren Browser, Betriebssystem, etc.
-

## Entwicklerdaten
Diese Daten werden automatisch generiert und sind für die Fehlerbehebung notwendig.
URL: ${window.location.href}
Nachricht: ${title} - ${message}
Fehler: ${errorMessage || '-'}
Details: ${errorStr.slice(0, 2048)}
`;
    const subject = $localize`:@@error-report-subject:FIT Fehlerbericht`;
    const link = `mailto:fit@uni-kassel.de?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(link, '_blank');
  }
}
